import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useTranslation } from "react-i18next";
import { subscribeToApiTimeout } from "../services/apiTimeoutEvents";

const GlobalApiTimeoutAlert = () => {
  const { t } = useTranslation();
  const [notification, setNotification] = useState({
    key: 0,
    open: false,
  });

  useEffect(
    () =>
      subscribeToApiTimeout(() => {
        setNotification((current) => ({
          key: current.key + 1,
          open: true,
        }));
      }),
    []
  );

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;

    setNotification((current) => ({
      ...current,
      open: false,
    }));
  };

  return (
    <Snackbar
      key={notification.key}
      open={notification.open}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert
        elevation={6}
        variant="filled"
        severity="error"
        onClose={handleClose}
        sx={{ width: "100%" }}
      >
        {t("common.api_timeout")}
      </Alert>
    </Snackbar>
  );
};

export default GlobalApiTimeoutAlert;
